import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, COMPANY } from "@/components/site/LegalLayout";

export const Route = createFileRoute("/klachten")({
  head: () => ({
    meta: [
      { title: "Klachtenregeling — Elvion Group Nederland" },
      { name: "description", content: "Een klacht indienen bij Elvion Group Nederland? Lees hoe u een klacht meldt, welke gegevens wij nodig hebben en binnen welke termijn u een reactie ontvangt." },
      { name: "robots", content: "index,follow" },
      { property: "og:title", content: "Klachtenregeling — Elvion Group Nederland" },
      { property: "og:description", content: "Zo dient u een klacht in bij Elvion Group Nederland. Snelle en persoonlijke afhandeling door onze klantenservice." },
      { property: "og:url", content: "https://elvion-group.nl/klachten" },
    ],
    links: [{ rel: "canonical", href: "https://elvion-group.nl/klachten" }],
  }),
  component: () => (
    <LegalLayout
      title="Klachtenregeling"
      intro="Het kan altijd voorkomen dat er iets niet helemaal gaat zoals gepland. Wij lossen klachten graag snel en persoonlijk op. Komen we er samen niet uit, dan kunt u kosteloos gebruikmaken van onafhankelijke geschillenbemiddeling."
    >
      <h2>1. Klacht indienen bij ons</h2>
      <p>Heeft u een klacht over een product, een bestelling of onze dienstverlening? Neem dan binnen bekwame tijd — en volledig omschreven — contact met ons op via één van deze kanalen:</p>
      <ul>
        <li><strong>E-mail (voorkeur):</strong> <a href={`mailto:${COMPANY.email}?subject=Klacht%20-%20ordernummer`}>{COMPANY.email}</a></li>
        <li><strong>Telefoon:</strong> {COMPANY.phone} (ma t/m vr 09:00–17:00)</li>
        <li><strong>Post:</strong> {COMPANY.name}, t.a.v. Klachtenafhandeling, {COMPANY.address}, {COMPANY.postal} Wageningen</li>
      </ul>

      <h2>2. Welke gegevens hebben wij nodig?</h2>
      <p>Hoe completer uw melding, hoe sneller wij een passende oplossing kunnen bieden. Vermeld daarom bij uw klacht:</p>
      <ul>
        <li><strong>Ordernummer</strong> of factuurnummer (indien van toepassing)</li>
        <li><strong>Naam</strong> en het e-mailadres/telefoonnummer waarop wij u kunnen bereiken</li>
        <li><strong>Duidelijke omschrijving</strong> van de klacht: wat is er gebeurd, wanneer en waar</li>
        <li>Betrokken product(en) — inclusief type-/serienummer als het om een defect gaat</li>
        <li><strong>Foto's of video's</strong> die het probleem laten zien (bij schade, defect of onjuiste levering)</li>
        <li>De <strong>gewenste oplossing</strong> (herstel, vervanging, terugbetaling of iets anders)</li>
      </ul>

      <h2>3. Verwachte verwerkingstijden</h2>
      <ul>
        <li><strong>Ontvangstbevestiging:</strong> binnen 1 werkdag</li>
        <li><strong>Inhoudelijke reactie:</strong> binnen 14 dagen na ontvangst van uw klacht</li>
        <li><strong>Complex onderzoek</strong> (bijv. beoordeling defect door leverancier): wij laten binnen 14 dagen weten hoeveel extra tijd wij nodig hebben en houden u tussentijds op de hoogte</li>
        <li><strong>Uitvoering van de oplossing</strong> (terugbetaling, vervanging, herstel): zo snel mogelijk, doorgaans binnen 5–10 werkdagen na akkoord</li>
      </ul>
      <p>Klachten worden vertrouwelijk en zorgvuldig behandeld door onze klantenservice.</p>


      <h2>4. Geschilbemiddeling via WebwinkelKeur</h2>
      <p>Het kan altijd voorkomen dat er iets niet helemaal gaat zoals gepland. We raden u aan om klachten eerst bij ons kenbaar te maken door te mailen naar <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>. Leidt dit niet tot een oplossing, dan is het mogelijk om uw geschil aan te melden voor bemiddeling via WebwinkelKeur via <a href="https://www.webwinkelkeur.nl/kennisbank/consumenten/geschil" target="_blank" rel="noopener">https://www.webwinkelkeur.nl/kennisbank/consumenten/geschil</a>.</p>

      <h2>5. Uw wettelijke rechten</h2>
      <p>Deze klachtenregeling laat uw wettelijke rechten onverlet, waaronder het recht om zich tot de bevoegde rechter te wenden. Op onze overeenkomsten is Nederlands recht van toepassing.</p>

      <h2>Contact</h2>
      <p>{COMPANY.name} — {COMPANY.email} — {COMPANY.phone}</p>
    </LegalLayout>
  ),
});
